/* eslint-disable arrow-body-style */
/* eslint-disable quote-props */
(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('ExportadorCtrl', ExportadorCtrl);

  ExportadorCtrl.$inject = [
    '$scope',
    '$rootScope',
    'LoadingService',
    'MessagesService',
    'ExportadorService'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function ExportadorCtrl($scope, $rootScope, LoadingService, MessagesService, ExportadorService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.step = 1;
    vm.availableTypes = [];
    vm.selectedType = null;
    vm.availableFilters = [];
    vm.oldAvailableFilters = [];
    vm.availableAttributes = []; // não usado por enquanto
    // eslint-disable-next-line no-empty-function
    vm.noop = () => {};
    vm.filters = {};
    vm.loadingRelatorio = false;

    //////////////////////////////////////////
    // Bindable methods
    vm.submitType = submitType;
    vm.submitFilters = submitFilters;
    vm.reset = reset;
    vm.isValid = isValid;

    //////////////////////////////////////////
    // Function declarations

    function loadTypes() {
      return ExportadorService.availableTypes()
        .then((types) => {
          vm.availableTypes = types;
        })
        .catch((err) => {
          console.error('Não foi possível carregar os tipos:', err);
          MessagesService.alert('Não foi possível carregar os tipos de relatório disponíveis.');
        });
    }

    const functionMap = {
      'filterEstadiosFenologicos': filterEstadioFenologicos,
      'filterPluviometros': filterPluviometros
    };

    function loadFilters() {
      return ExportadorService.availableFilters(vm.selectedType)
        .then((data) => {
          vm.availableFilters = data.filters;
          vm.oldAvailableFilters = JSON.parse(JSON.stringify(data.filters));
          vm.availableAttributes = data.attributes;

          data.filters.forEach((filter) => {
            if (filter.default) {
              vm.filters[filter.name] = filter.default;
            }
          });

          vm.availableFilters.forEach((filter) => {
            if (filter.function) {
              filter.function = functionMap[filter.function];
            } else {
              filter.function = vm.noop;
            }
          });
        })
        .catch((err) => {
          console.error('Não foi possível buscar os filtros:', err);
          MessagesService.alert('Não foi possível buscar os filtros do tipo selecionado.');
        });
    }

    function filterEstadioFenologicos(selected) {
      vm.oldAvailableFilters.forEach((oldFilter) => {
        if (oldFilter.filtered_by === 'atividade') {
          const filter = vm.availableFilters.find((newFilter) => oldFilter.name === newFilter.name);
          filter.items = oldFilter.items;

          if (!selected) {
            vm.filters[oldFilter.name] = [];
          } else {
            vm.filters[oldFilter.name] = (vm.filters[oldFilter.name] || []).filter((value) => {
              return value.cd_atividade === selected.id;
            });
            const filteredItens = oldFilter.items.filter((item) => item.cd_atividade === selected.id);
            filter.items = filteredItens.sort((primeiroEstadio, segundoEstadio) => {
              return primeiroEstadio.ordem - segundoEstadio.ordem;
            });
          }
        }
      });
    }

    function filterPluviometros(propriedades) {
      const propriedadesIds = propriedades.map((propriedade) => propriedade.id);

      vm.oldAvailableFilters.forEach((oldFilter) => {
        if (oldFilter.filtered_by === 'propriedades') {
          const filter = vm.availableFilters.find((newFilter) => oldFilter.name === newFilter.name);
          filter.items = oldFilter.items;

          vm.filters[oldFilter.name];
          if (propriedades.length) {
            filter.items = oldFilter.items.filter((item) => propriedadesIds.includes(item.cd_propriedade));
            const valuesToFilter = vm.filters[oldFilter.name] || [];
            vm.filters[oldFilter.name] = valuesToFilter.filter((value) => {
              return propriedadesIds.includes(value.cd_propriedade);
            });
          } else {
            vm.filters[oldFilter.name] = [];
          }
        }
      });
    }

    function submitType(event) {
      if (event) {
        event.preventDefault();
      }

      LoadingService.showLoading();
      loadFilters()
        .then(() => vm.step++)
        .finally(LoadingService.hideLoading);
    }

    function submitFilters(event) {
      if (event) {
        event.preventDefault();
      }

      LoadingService.showLoading();
      ExportadorService.createReport(vm.selectedType, vm.filters)
        .then((data) => {
          const relatorio = {
            job_id: data.job_id,
            name: vm.selectedType.description,
            status: 'working'
          };

          $rootScope.relatorio = relatorio;

          verifyJobProgress();

          vm.step++;
        })
        .catch((err) => {
          console.error('Não foi possível gerar o relatório:', err);
          MessagesService.alert('Não foi possível gerar o relatório com os filtros selecionados.');
        })
        .finally(LoadingService.hideLoading);
    }

    function reset() {
      vm.availableAttributes = [];
      vm.availableFilters = [];
      vm.filters = {};
      vm.selectedType = null;
      vm.step = 1;
    }

    function isValid() {
      const required = vm.availableFilters.filter((f) => f.required);
      return Object.keys(vm.filters).length >= required.length &&
        !required.some((f) => !vm.filters[f.name]);
    }

    function verifyJobProgress() {
      vm.loadingRelatorio = true;
      const clear = (intervalo) => {
        vm.loadingRelatorio = false;
        $rootScope.relatorio = null;
        clearInterval(intervalo);
      };
      const intervalo = setInterval(() => {
        ExportadorService.getJobProgress($rootScope.relatorio).then((data) => {
          if (data.status === 'complete') {
            $rootScope.$broadcast('terminou_exportador', { url: data.message, name: $rootScope.relatorio.name });
            clear(intervalo);
          }
          if (data.status === 'failed') {
            $rootScope.$broadcast('falhou_exportador', { url: data.message, name: $rootScope.relatorio.name });
            clear(intervalo);
          }
        });
      }, 15000);
    }

    //////////////////////////////////////////
    // Controller logic

    LoadingService.showLoading();

    $scope.$root.initialize
      .then(() => {
        if ($rootScope.relatorio) {
          vm.step = 3;
          vm.loadingRelatorio = true;
          return Promise.resolve();
        }
        return loadTypes();
      })
      .finally(LoadingService.hideLoading);

    $scope.$on('terminou_exportador', () => {
      vm.loadingRelatorio = false;
    });

    $scope.$on('falhou_exportador', () => {
      vm.loadingRelatorio = false;
    });
  }
}());
